import { Box, Typography } from '../../ui';

/**
 * Section heading for the course editor's Card sections — title and
 * (optional) subtitle inline on one row. Title is large + bold; subtitle
 * reads as a quiet inline description. Em-dash separates them when both
 * are present.
 */
export default function SectionLabel({ title, subtitle }: { title: string; subtitle?: string }) {
  return (
    <Box
      sx={{
        mb: 2,
        display: 'flex',
        alignItems: 'baseline',
        gap: 1.25,
        flexWrap: 'wrap',
      }}
    >
      <Typography variant="h6" fontWeight={700} sx={{ lineHeight: 1.2 }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 400 }}>
          — {subtitle}
        </Typography>
      )}
    </Box>
  );
}
